// @ts-strict-ignore
import {Component, Injector, OnInit} from "@angular/core";
import {
	BasicMaterialDialog,
	MatDialogDataBaseInput,
	MatDialogDataBaseOutput,
} from "../../basic-material-dialog/basic-material-dialog.directive";

export interface PROMPT_DIALOG_INPUT extends MatDialogDataBaseInput {
	title: string;
	description: string;
	textType: "text" | "password";
	promptType: "info" | "danger";
	validationRegex: string;
	okText: string;
	cancelText: string;
	maxlength: number;
	preFilledText?: string;
}

export interface PROMPT_DIALOG_OUTPUT extends MatDialogDataBaseOutput {
	text: string;
}

@Component({
	selector: "sim-prompt-dialog",
	templateUrl: "./prompt-dialog.component.html",
	styleUrls: ["./prompt-dialog.component.scss"],
	standalone: false,
})
export class PromptDialogComponent
	extends BasicMaterialDialog<PromptDialogComponent, PROMPT_DIALOG_INPUT, PROMPT_DIALOG_OUTPUT>
	implements OnInit
{
	public text: string;

	constructor(_injector: Injector) {
		super(_injector);
		if (!!this.data.preFilledText) this.text = this.data.preFilledText;
	}
}
